import { API_URL } from '@/const';
import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { TicketStatus } from '@/types/enums';
import { ITicket } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/my/tickets';
const $urlActionsUpload = '/my/tickets/actions/upload';

export interface IGetRequest {
  status: TicketStatus;
  ticketNo: string;
  keyword: string;
  offset: number;
  limit: number;
}

export interface IGetResult {
  isTicket: boolean;
  count: number;
  tickets: ITicket[];
}

export interface ISubmitRequest {
  priority: string;
  category: string;
  content: string;
  fileUrls: string[];
}

export interface IUploadResult {
  name: string;
  url: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  getUploadUrl() {
    return API_URL + $urlActionsUpload;
  },
};
